import { Component, computed, input, output } from '@angular/core';

export const TRANSPARENT_COLOR = 'transparent';

@Component({
  selector: 'lib-color-picker',
  templateUrl: './color-picker.component.html',
})
export class ColorPickerComponent {
  public readonly label = input<string>();

  public readonly value = input<string>();

  public readonly transparent = input(false);

  public readonly displayValue = input<string>();

  public readonly disabled = input(false);

  public readonly changed = output<string>();

  protected readonly isTransparent = computed(() => {
    if (this.transparent()) {
      return true;
    }

    const value = this.value();

    return value == null || value === TRANSPARENT_COLOR;
  });

  protected readonly colorInputValue = computed(() => this.value() ?? '#000000');

  protected readonly swatchLabel = computed(() => this.displayValue() ?? this.value() ?? '');

  applyValue(event: Event): void {
    if (this.disabled() || this.isTransparent()) {
      return;
    }

    this.changed.emit((event.target as HTMLInputElement).value);
  }
}
